import React from "react";
import { LOGO_URI } from "../../assets/images";
import { PERSONAL } from "../../data";
import { useScrollTo } from "../../hooks/useScrollTo";

const NAV_SECTIONS = [
  "About",
  "Skills",
  "Experience",
  "Projects",
  "Contact",
] as const;

interface NavbarProps {
  dark: boolean;
  onToggleTheme: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ dark, onToggleTheme }) => {
  const { handleAnchorClick } = useScrollTo();

  return (
    <nav>
      {/* Logo */}
      <a
        href="#hero"
        className="nav-logo"
        onClick={handleAnchorClick("hero")}
        aria-label="Go to top"
      >
        <img src={LOGO_URI} alt="DRJ logo" className="nav-logo-img" />
      </a>

      {/* Nav links */}
      <ul className="nav-links">
        {NAV_SECTIONS.map((section) => (
          <li key={section}>
            <a href={`#${section}`} onClick={handleAnchorClick(section)}>
              {section}
            </a>
          </li>
        ))}
      </ul>

      {/* Right-side actions */}
      <div className="nav-right">
        <button
          className="theme-toggle"
          onClick={onToggleTheme}
          aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
        >
          {dark ? "☀" : "☾"}
        </button>

        <a href={`mailto:${PERSONAL.email}`} className="nav-cta">
          Hire Me
        </a>
      </div>
    </nav>
  );
};
